import { render } from "./HelpView.vue?vue&type=template&id=c4d2ff40&scoped=true"
const script = {}

import "./HelpView.vue?vue&type=style&index=0&id=c4d2ff40&scoped=true&lang=css"

import exportComponent from "/Users/erik/code/oliebol/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d2ff40"]])

export default __exports__